// Generated by CoffeeScript 2.7.0
var HumanCategoryMap, PushAgent, datetime_picker, group_options, popover;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import DateTimePickerPopover from 'trunks/vue/admin/components/date_time_picker_popover.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

HumanCategoryMap = {
  Namespace: '系统推送包',
  User: '自定义推送包'
};

datetime_picker = DateTimePickerPopover;

group_options = GroupOptions;

popover = Popover;

export default PushAgent = Vue.extend({
  components: {
    'datetime-picker': datetime_picker,
    'group-options': group_options,
    popover: popover
  },
  props: {
    push: Object,
    limitStart: {
      type: Date,
      default: function() {
        return new Date();
      }
    },
    limitEnd: Date
  },
  data: function() {
    var ref, ref1;
    return {
      scheduled_at: ((ref = this.push) != null ? ref.scheduled_at : void 0) && new Date((ref1 = this.push) != null ? ref1.scheduled_at : void 0),
      packages: [],
      selected_package: null
    };
  },
  template: `<div class="push-agent justify-box">
  <div class="content push-packages">
    <label>选择推送包:</label>
    <popover :caret='false' :blockContent='true' position='top' ref='pushPackagePopover'>
      <template slot='trigger'>
        <div class="input-control right-addon">
          <input type="text" placeholder='请选择' readonly v-model.trim='package_name' />
          <div class="addon">
            <i class="slp-caret-down"></i>
          </div>
        </div>
      </template>
      <template slot='content'>
        <group-options :groupedOptions='packages'
                       @valueChanged='valueChangedFunc' />
      </template>
    </popover>
  </div>
  <div class="content push-at">
    <label>选择开始时间:(默认现在)</label>
    <datetime-picker position='top'
                     customClass='content'
                     :limitStart='limitStart'
                     :limitEnd='limitEnd'
                     :initValue='scheduled_at'
                     @valueChanged='updatePushAt' />
  </div>
</div>`,
  computed: {
    package_name: function() {
      var ref;
      return (ref = this.selected_package) != null ? ref.name : void 0;
    }
  },
  created: function() {
    return this._fetchPackages();
  },
  methods: {
    getPushSetting: function() {
      var ref, ref1;
      return {
        scheduled_at: ((ref = this.scheduled_at) != null ? ref.strftime('YYYY-MM-DD hh:mm') : void 0) || '',
        push_package_id: (ref1 = this.selected_package) != null ? ref1.id : void 0
      };
    },
    updatePushAt: function(date) {
      this.scheduled_at = date;
      return this.$emit('valueChanged', this.getPushSetting());
    },
    valueChangedFunc: function(group_options_vm) {
      this.selected_package = group_options_vm.getSelectedOptions()[0];
      this.$refs.pushPackagePopover.close();
      return this.$emit('valueChanged', this.getPushSetting());
    },
    _fetchPackages: function() {
      return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor('push_packages', {
        _preview: true
      }), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json'
      }).done((push_packages, state, xhr) => {
        var grouped_push_packages, ref, ref1;
        if ((ref = this.push) != null ? ref.push_package_id : void 0) {
          this.selected_package = _.findWhere(push_packages, {
            id: this.push.push_package_id
          });
          if ((ref1 = this.selected_package) != null) {
            ref1._selected = true;
          }
        }
        grouped_push_packages = _.groupBy(push_packages, 'push_packageable_type');
        return _.each(HumanCategoryMap, (name, type) => {
          if (grouped_push_packages[type]) {
            return this.packages.push({
              name: name,
              multiple: false,
              options: grouped_push_packages[type],
              allow_clear: true
            });
          }
        });
      });
    }
  }
});
